import { useEffect, useState } from 'react';
import './App.css';
import { LanguageProvider } from './language-context.js';
import Nav from './nav.js';
import SectionHeader from './section-header.js';
import BlockExperience from './blocks/experience.js';
import BlockAbout from './blocks/about.js';
import Footer from './blocks/footer.js';

function App() {
  const [navVisible, setNavVisible] = useState(false);
  const [activeSection, setActiveSection] = useState(null);

  useEffect(() => {
    const header = document.getElementById('top');
    if (!header) return;
    const observer = new IntersectionObserver(
      ([entry]) => setNavVisible(!entry.isIntersecting),
      { threshold: 0 }
    );
    observer.observe(header);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const ids = ['experience', 'about', 'contact'];
    const elements = ids.map((id) => document.getElementById(id)).filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <LanguageProvider>
      <div className="App">

        <Nav visible={navVisible} activeSection={activeSection} />

        <SectionHeader />

        <BlockExperience />

        <BlockAbout />

        <Footer />

      </div>
    </LanguageProvider>
  );
}

export default App;
